import React from 'react';
import { SaremiStoreView } from './store/SaremiStoreView';

export const Shop: React.FC = () => {
  return <SaremiStoreView />;
};

export default Shop;
